import { render } from "./PromoTagPage.vue?vue&type=template&id=5787d433&lang=pug"
import script from "./PromoTagPage.vue?vue&type=script&lang=js"
export * from "./PromoTagPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__